// @flow

import type { SoilJobOperation } from 'hfty-operator-soil-jobs/types'

// Libs
import React, { Component } from 'react'
import _find from 'lodash/find'
import _isEmpty from 'lodash/isEmpty'

// Utils
import traverse from 'fc-utils/traverse'

// Components
import Button from '@react-mdc/button'
import { Errors } from 'hfty-components-errors'
import Select from 'react-select'

// Messages
import messages from '../messages'

// Constants
import { PROP_ASSIGNED_TO, PROP_STATUS, PROP_SUBFIELD } from 'hfty-model-soil-jobs'

// Components
import FormField from '@react-mdc/form-field'

const styles = {
  container: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    width: 300,
    backgroundColor: '#fff',
    color: '#fff',
    boxShadow: '-2px 0 2px rgba(0, 0, 0, 0.2)',
    padding: 15,
    overflow: 'auto',
  },
  componentStyle: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    minWidth: 350,
    maxWidth: '100vw',
    backgroundColor: '#fff',
    boxShadow: '-2px 0 2px rgba(0,0,0,0.1)',
    zIndex: 1000,
  },
  passwordError: {
    color: 'red',
  },
  dropDown: {
    float: 'right',
  },
  formField: {
    width: 300,
  },
  buttonDiv: {
    marginTop: 20,
  },
}

type Props = {
  operation: SoilJobOperation,
  fieldSelectorOptions: Array,
  userSelectorOptions: Array,
  subfields: Array,
  onChange: Function,
  onCancel: Function,
  onSubmit: Function,
}

const getAssignedTo = traverse(['operation', 'model', PROP_ASSIGNED_TO], { default: '' })
const getSubfield = traverse(['operation', 'model', PROP_SUBFIELD], { default: '' })

export default class AddSoilJob extends Component {
  props: Props
  onSubmit: Function
  onCancel: Function

  constructor(props: Props) {
    super(props)

    this.onChangeSubfield = this.onChangeSubfield.bind(this)
    this.onChangeAssignedTo = this.onChangeAssignedTo.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onCancel = this.onCancel.bind(this)
  }

  onSubmit(e: Event) {
    e.preventDefault()
    let jobField = this.props.operation.model[PROP_SUBFIELD]
    let subfield = _find(this.props.subfields, { parent: jobField })

    this.props.operation.model[PROP_SUBFIELD] = subfield.id
    this.props.operation.model[PROP_STATUS] = 'Set Grid'

    this.props.onSubmit([this.props.operation])
  }

  onCancel(e: Event) {
    e.preventDefault()

    this.props.onCancel([this.props.operation])
  }

  onChangeSubfield(e: Event) {
    this.props.onChange({
      ...this.props.operation,
      model: {
        ...this.props.operation.model,
        [PROP_SUBFIELD]: e.value,
      },
    })
  }

  onChangeAssignedTo(e: Event) {
    this.props.onChange({
      ...this.props.operation,
      model: {
        ...this.props.operation.model,
        [PROP_ASSIGNED_TO]: e.value,
      },
    })
  }

  render(): React.Element<any> {
    if (_isEmpty(this.props.operation) || this.props.operation.operation !== 'ADD') {
      return null
    }

    return (
      <form style={styles.container} onSubmit={this.onSubmit}>
        <FormField>
          <Errors errors={this.props.operation.errors} messages={messages} />
        </FormField>
        <FormField key="subfield-selector" style={styles.formField}>
          <label htmlFor="subfield-selector">Field</label>
          <Select
            name="subfield-selector"
            options={this.props.fieldSelectorOptions}
            onChange={this.onChangeSubfield}
            style={styles.dropDown}
            value={getSubfield(this.props)}
          />
        </FormField>
        <FormField key="assignedTo-selector" style={styles.formField}>
          <label htmlFor="assignedTo-selector">Assigned To</label>
          <Select
            name="assignedTo-selector"
            options={this.props.userSelectorOptions}
            onChange={this.onChangeAssignedTo}
            style={styles.dropDown}
            value={getAssignedTo(this.props)}
          />
        </FormField>
        <FormField key="status-selector" style={styles.formField}>
          <label htmlFor="status-selector">Status</label>
          <Select name="status-selector" placeholder={'Set Grid'} style={styles.dropDown} disabled />
        </FormField>
        <div style={styles.buttonDiv}>
          <Button raised primary onClick={this.onSubmit}>
            {'Submit'}
          </Button>
          <Button raised onClick={this.onCancel} primary style={{ marginLeft: 10 }}>
            {'Cancel'}
          </Button>
        </div>
      </form>
    )
  }
}
